<template>
    <div class="gallery-component">
        <v-tabs
            v-model="tab"
            class="categories-container flex justify-center mb-8 sm:mb-12"
        >
            <v-tab v-for="category in categories" :key="category.id">
                {{ category.name[lang] }}
            </v-tab>
        </v-tabs>

        <gallery-slider
            :slider-initial-image-index="sliderInitialImageIndex"
            :images="sliderImages"
            v-show="showSlider"
            @close="closeSlider"
        />

        <v-tabs-items v-model="tab">
            <v-tab-item v-for="{ id, images } in categories" :key="id">
                <div class="images-grid">
                    <div
                        v-for="[image, title] in images"
                        :key="image"
                        @click="openSlider(image)"
                        class="image-wrapper cursor-pointer has-hover-overlay"
                    >
                        <img :src="image" :title="title" />
                    </div>
                </div>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
export default {
    props: {
        categories: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            tab: null,
            lang: window.appLocale,
            showSlider: false,
            sliderInitialImageIndex: 0
        };
    },

    computed: {
        sliderImages() {
            return this.categories.flatMap(({ images }) => images);
        }
    },

    methods: {
        openSlider(imageUrl) {
            this.sliderInitialImageIndex = this.sliderImages.findIndex(
                ([url]) => url === imageUrl
            );
            this.showSlider = true;
            document.documentElement.style.overflow = "hidden";
        },
        closeSlider() {
            this.sliderInitialImageIndex = -1;
            this.showSlider = false;
            document.documentElement.style.overflow = "visible";
        }
    }
};
</script>

<style lang="scss" scoped>
.theme--light.v-tabs-items {
    background-color: transparent;
}

.categories-container {
    margin-top: 40px;
}

.images-grid {
    --columns: 2;
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    gap: 10px;
    background-color: transparent;

    @media (min-width: 375px) {
        --columns: 3;
    }
    @media (min-width: 640px) {
        gap: 30px;
    }

    .image-wrapper {
        position: relative;
        height: 0;
        padding-top: 100%;

        img {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            object-fit: cover;
        }
    }
}
</style>
